import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { useLocation, useNavigate } from 'react-router-dom';
import { mobilePoint } from 'src/styles/globalStyle';

const Wrapper = styled.div`
  background-color: ${colors.white};
  box-shadow: 0 0 5px rgba(67, 67, 67, 0.08);
  width: 100%;
  height: fit-content;
  border-radius: 4px;

  @media (max-width: ${mobilePoint}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 0 1em;
  }
`;
const Item = styled.div<{ isActive: boolean; color: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 70px;
  padding: 1.5em 1.5em;
  cursor: pointer;

  border-right: ${(props) => (props.isActive ? '3px solid' + props.color : 'none')};
  color: ${(props) => (props.isActive ? props.color : 'initial')};
  font-family: ${(props) => (props.isActive ? 'NotoSansTC-Bold' : 'initial')};

  @media (max-width: ${mobilePoint}) {
    justify-content: center;
    gap: 1em;
    font-size: 20px;
    border-bottom: ${(props) => (props.isActive ? '3px solid' + props.color : 'none')};
    border-right: none;
  }
  
  /* 新增：聚焦時的外框樣式 (參考之前討論的技巧) */
  &:focus {
  	outline: 2px solid #000000;
  	outline-offset: -2px;
  }
`;
const Title = styled.div``;
const Icon = styled.div``;

export interface ListComponent {
  title: string;
  href: string;
  icon: JSX.Element;
}

interface Iprops {
  components: ListComponent[];
  color: string;
}

/**
 * 側邊功能列表
 */
const SideList: React.FC<Iprops> = ({ components, color }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // 處理鍵盤觸發（Enter 或 Space）
  const handleKeyDown = (e: React.KeyboardEvent, href: string) => {
  	if (e.key === 'Enter' || e.key === ' ') {
  		e.preventDefault(); // 防止 Space 鍵捲動頁面
  		navigate(href);
      }
  };
  return (
    <Wrapper>
      {components.map((item) => {
        return (
          <Item
            key={item.title}
            onClick={() => navigate(item.href)}
            isActive={pathname === item.href}
            color={color}
			tabIndex={0} 
			role="button" 
			aria-label={item.title + '頁籤'}
			onKeyDown={(e) => handleKeyDown(e, item.href)}
          >
            <Title>{item.title}</Title>
            <Icon>{item.icon}</Icon>
          </Item>
        );
      })}
    </Wrapper>
  );
};

export default SideList;
